import CorePreviewLine from '@components/CorePreviewLine'
import { formatCurrencyForDisplay } from '@utils'
import { useCurrencies } from 'mmfintech-backend-api'
import type { CheckoutDetails, TransactionViewPortal } from 'mmfintech-backend-api/types'
import { formatFloat, formatMoney, tr } from 'mmfintech-commons'
import moment from 'moment'

import './styled/payoutPreview.scss'

export const PayoutPreview = ({
  previewData,
  checkoutDetails,
  trn
}: {
  previewData: any
  checkoutDetails: CheckoutDetails
  trn?: TransactionViewPortal
}) => {
  const { id, reqTime } = trn || {}
  const { fee, feeCurrency, walletAmount, walletCurrency } = previewData || {}
  const { customerName, customerEmail } = checkoutDetails || {}

  const { getCurrencyPrecision } = useCurrencies()

  return (
    <div className='payout-preview-wrapper'>
      <div className='payout-amount-section'>
        <div className='amount-label'>{tr('FRONTEND.DEPOSIT.AMOUNT_LABEL', 'Amount')}</div>
        <div className='amount-content'>
          {walletAmount > 0 && walletCurrency?.length
            ? formatFloat(walletAmount, getCurrencyPrecision(walletCurrency))
            : null}
          <span className='amount-currency'>{walletAmount > 0 && formatCurrencyForDisplay(walletCurrency)}</span>
        </div>
      </div>

      <div className='payout-details-section'>
        <CorePreviewLine
          className={'transaction-payout-single-content'}
          title={tr('FRONTEND.TRANSACTIONS.PAYOUT_MODAL.CUSTOMER_NAME', 'Customer name')}
          text={customerName}
        />
        <CorePreviewLine
          className={'transaction-payout-single-content'}
          title={tr('FRONTEND.TRANSACTIONS.PAYOUT_MODAL.CUSTOMER_EMAIL', 'Customer email')}
          text={customerEmail}
        />
        <CorePreviewLine
          className={'transaction-payout-single-content'}
          title={tr('FRONTEND.PENDING_APPROVALS.MODAL.TRANSACTION_ID', 'Transaction ID')}
          text={id?.toString()}
        />
        <CorePreviewLine
          className={'transaction-payout-single-content'}
          title={tr('FRONTEND.EXPENSES.LABEL.DATE', 'Date')}
          text={moment(reqTime).format('DD/MM/YYYY')}
        />
        {fee > 0 ? (
          <CorePreviewLine
            className={'transaction-payout-single-content'}
            title={tr('FRONTEND.EXCHANGE.FEE', 'Fee')}
            text={formatMoney(fee, formatCurrencyForDisplay(feeCurrency))}
          />
        ) : null}
      </div>
    </div>
  )
}
